import { memo } from 'react';
import cx from 'classnames';

import { Text } from 'components';
import SpeakerImage from 'components/Speaker/Speaker.Image';

import styles from './LiveEvent.module.scss';

export type LiveEventMainPlayerProps = {
  name?: string;
  image?: string;
  seatIndex?: number;
};

const LiveEventMainPlayer = ({ name, image, seatIndex }: LiveEventMainPlayerProps): JSX.Element => (
  <div className={styles.player}>
    <SpeakerImage className={cx(styles.image, 'mb-14 mx-auto')} image={image} name={name} seatIndex={seatIndex} />
    <Text className={cx(styles.name, 'text-center')} size="h1" weight="bold">
      {name}
    </Text>
  </div>
);

export default memo(LiveEventMainPlayer);
